import { getAuth } from "firebase/auth";

export const fetchApiKey = async () => {
  try {
    // Initialize Firebase Authentication

    const auth = getAuth();

    // Get the current user's ID token
    const user = auth.currentUser;

    if (!user) {
      throw new Error("User is not authenticated.");
    }

    const token = await user.getIdToken();
    // Call the Cloud Function
    const response = await fetch(
      "https://us-central1-one-address-53a06.cloudfunctions.net/getApiKey",
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`, // Pass the user token for authentication
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch API key.");
    }

    const data = await response.json();
    return data.apiKey; // Return the API key from the response
  } catch (error) {
    console.error("Error fetching API key:", error);
    throw error; // Rethrow to handle errors in the calling component
  }
};
